/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import Router from 'vue-router';
import Axios from 'axios';
import Cookies from 'vue-cookies';
import * as GoogleMap from 'vue2-google-maps';
import * as PrettyFileIcons from 'pretty-file-icons';

import HelloWorld from '@/components/HelloWorld';
import LoginPage from '@/pages/LoginPage';
// import TestPage from '@/pages/Test' // used in the past to diagnose "No such host is known" issues, no longer needed, uncomment if you wish to diagnose another issue
import RedirectConfigCode from '@/pages/RedirectConfigCode';

import HomePage from '@/pages/HomePage';
import HomeIndex from '@/pages/Home/HomeIndex';

import HomeAbout from '@/pages/Home/AboutPage';
import HomeContact from '@/pages/Home/ContactPage';

import StatusPage from '@/pages/Home/StatusPage';

import DocAIDataRetrievePage from '@/pages/DocAIDataRetrievePage';

//#region State Management
import Vuex from './js/vuex.js';
//#endregion

//#region Knowledge Base
import KnowledgeBase from '@/pages/KnowledgeBase.vue';
import KnowledgeBaseView from '@/pages/KnowledgeBaseView.vue';
//#endregion

//#region Reports
import ReportsHome from '@/pages/Reports/ReportsHome.vue';
import DefaultReport from '@/pages/Reports/DefaultReport.vue';
import BookingConfirmation from '@/pages/Reports/BookingConfirmation.vue';
// import ShippingNoteReport from '@/pages/Reports/ShippingNoteReport.vue'

//#endregion

//#region Dashboard pages
// import HaulageDashboard from '@/pages/Home/Dashboard/HaulageDashboardPage'
import HaulageDashboardV2 from '@/pages/Home/Dashboard/HaulageDashboardPageV2';
// import TaskSchedule from '@/pages/Home/Dashboard/TaskSchedulePage'
import TaskSchedulePageV2 from '@/pages/Home/Dashboard/TaskSchedulePageV2';
import JobMilestone from '@/pages/Home/Dashboard/JobMilestonePage';
import JobInquiries from '@/pages/Home/Dashboard/JobInquiriesPage';
import TemplatePage from '@/pages/Home/Dashboard/TemplatePage';
import ContainerThroughputPOLPOD from '@/pages/Home/Dashboard/ContainerThroughputPOLPODPage';
import POLPODDrillThrough from '@/pages/Home/DrillThroughPages/POLPODDrillThrough';
import ContainerThroughput from '@/pages/Home/Dashboard/ContainerThroughputPage';
import ContainerThroughputDrillThrough from '@/pages/Home/DrillThroughPages/ContainerThroughputDrillThrough';
import LCLThroughputPOLPOD from '@/pages/Home/Dashboard/LCLThroughputPOLPODPage';
import LCLDrillThrough from '@/pages/Home/DrillThroughPages/LCLDrillThrough';
import SalesDashboard from '@/pages/Home/Dashboard/SalesDashboardPage';
import SalesAnalysisDrillThrough from '@/pages/Home/DrillThroughPages/SalesAnalysisDrillThrough';
import HaulageRevenueDashboard from '@/pages/Home/Dashboard/HaulageRevenueDashboardPage';
import HaulageRevenueDrillThrough from '@/pages/Home/DrillThroughPages/HaulageRevenueDrillThrough';
import HaulageRevenueByPMDriver from '@/pages/Home/Dashboard/HaulageRevenueByPMDriverPage';
import HaulageRevenueByPMDriverDrillThrough from '@/pages/Home/DrillThroughPages/HaulageRevenueByPMDriverDrillThrough';
import ProfitLossDashboard from '@/pages/Home/Dashboard/ProfitLossDashboardPage';
import ProfitLossDrillThrough from '@/pages/Home/DrillThroughPages/ProfitLossDrillThrough';
import DeliveryCollectionKPI from '@/pages/Home/Dashboard/DeliveryCollectionKpiPage';
import DelColKPIDrillThrough from '@/pages/Home/DrillThroughPages/DelColKPIDrillThrough';
import DocumentAi from '@/pages/Home/Dashboard/DocumentAi';
import DocumentApproval from '@/pages/Home/Dashboard/DocumentApproval';
import DocumentApprovalCreator from '@/pages/Home/Dashboard/DocumentApprovalCreator';
import JobCosting from '@/pages/Home/Dashboard/JobCosting';
import JobCostingDrillThrough from '@/pages/Home/DrillThroughPages/JobCostingDrillThrough';
import TurnaroundAnalysis from '@/pages/Home/Dashboard/TurnaroundAnalysisPage';
import TurnaroundAnalysisDrillThrough from '@/pages/Home/DrillThroughPages/TurnaroundAnalysisDrillThrough';
import EquipmentDowntime from '@/pages/Home/Dashboard/EquipmentDowntime';
import EquipmentDowntimeDrillThrough from '@/pages/Home/DrillThroughPages/EquipmentDowntimeDrillThrough';
import EquipmentExpenses from '@/pages/Home/Dashboard/EquipmentExpenses';
import EquipmentExpensesDrillThrough from '@/pages/Home/DrillThroughPages/EquipmentExpensesDrillThrough';
//#endregion

//#region Freight Forwarding pages
import FreightBooking from '@/pages/Home/FreightForwarding/FreightBooking';
import PrintBookingConfirmation from '@/pages/Home/FreightForwarding/PrintBookingConfirmation';
import PrintHouseBL from '@/pages/Home/FreightForwarding/PrintHouseBL';
import DeliveryNotes from '@/pages/Home/FreightForwarding/DeliveryNotes';
import PrintDeliveryNotes from '@/pages/Home/FreightForwarding/PrintDeliveryNotes';
import eDeliveryNotes from '@/pages/Home/FreightForwarding/eDeliveryNotes';
import Job from '@/pages/Home/FreightForwarding/JobPage';
import ROT from '@/pages/Home/FreightForwarding/ROTPage.vue';
import eROT from '@/pages/Home/FreightForwarding/eROT.vue';
import FreightForwardingReport from '@/pages/Home/FreightForwarding/FreightForwardingReport.vue';
import ImportCIPL from '@/pages/Home/FreightForwarding/ImportCIPL.vue';
import PrintNotice from '@/pages/Home/FreightForwarding/PrintNotice.vue';
//#endregion

//#region Haulage pages
import VehicleSchedule from '@/pages/Home/Haulage/VehicleSchedulePage';
import VehicleScheduleV2 from '@/pages/Home/Haulage/VehicleSchedulePageV2';
import VehicleScheduleV4 from '@/pages/Home/Haulage/VehicleSchedulePageV4';
//import VehicleTracking from '@/pages/Home/Haulage/VehicleTrackingPage'
// import VehicleTracking from '@/pages/Home/Haulage/VehicleTrackingV2Page'
import VehicleTracking from '@/pages/Home/Haulage/VehicleTrackingV2Page';
import VehicleTrackingV3 from '@/pages/Home/Haulage/VehicleTrackingV3Page';
import HaulageCapacity from '@/pages/Home/Haulage/HaulageCapacityPage';
import HaulageJob from '@/pages/Home/Haulage/HaulageJobPage';
import HaulageReport from '@/pages/Home/Haulage/HaulageReport.vue';
import MovementUpdate from '@/pages/Home/Haulage/MovementUpdate.vue';
import MovementHistory from '@/pages/Home/Haulage/MovementHistoryPage.vue';
import Consignment from '@/pages/Home/Haulage/Consignment.vue';
//#endregion

//#region Trucking pages
import BatchBooking from '@/pages/Home/Trucking/BatchBooking.vue';
import BatchOrder from '@/pages/Home/Trucking/BatchOrder.vue';
import TruckingSchedule from '@/pages/Home/Trucking/TruckingSchedule.vue';
import TripReport from '@/pages/Home/Trucking/TripReport.vue';
import PlanAndAssign from '@/pages/Home/Trucking/PlanAndAssign.vue';
import TruckingJob from '@/pages/Home/Trucking/TruckingJob.vue';
import TruckingReport from '@/pages/Home/Trucking/TruckingReport.vue';
import TruckingMovementUpdate from '@/pages/Home/Trucking/TruckingMovementUpdate.vue';
// import TruckingJobDetails from '@/pages/Home/Trucking/TruckingJobDetails.vue'
// import TruckingJobTest from '@/pages/Home/Trucking/TruckingJobTest.vue'
//#endregion

//#region workshop pages
import WorkshopJob from '@/pages/Home/Workshop/WorkshopJob.vue';
import PartInventory from '@/pages/Home/Workshop/PartInventory.vue';
import EquipmentSchedule from '@/pages/Home/Workshop/EquipmentSchedule.vue';
import EquipmentReport from '@/pages/Home/Workshop/EquipmentReport.vue';
import PolicyAlerts from '@/pages/Home/Workshop/PolicyAlerts.vue';
//#endregion

//#region Settings pages
import UserManagement from '@/pages/Home/Settings/UserManagementPage';
import RoleManagement from '@/pages/Home/Settings/RoleManagementPage';
import UserOptions from '@/pages/Home/Settings/UserOptionsPage';
import ReportDesigner from '@/pages/Home/Settings/ReportDesignerPage';
import SMKMessageTracking from '@/pages/Home/Settings/SMKMessageTracking';
import ReportDesignerV2 from '@/pages/Home/Settings/ReportDesignerPageV2';
import DesignerV2Page from '@/pages/Home/Settings/DesignerV2Page';
import DesignerV3Page from '@/pages/Home/Settings/DesignerV3Page';
//#endregion

//#region Logistics pages
import LogisticsHome from '@/pages/Home/Logistics/LogisticsHome';
import FRE from '@/pages/Home/Logistics/FREPage';
import FMS from '@/pages/Home/Logistics/FMSPage';
import HMS from '@/pages/Home/Logistics/HMSPage';
import WMS from '@/pages/Home/Logistics/WMSPage';
import CON from '@/pages/Home/Logistics/CONPage';
import EMS from '@/pages/Home/Logistics/EMSPage';
import CRUNCHIE1 from '@/pages/Home/Logistics/crunchie/crunchie1';
import CRUNCHIE2 from '@/pages/Home/Logistics/crunchie/crunchie2';
//#endregion

//#region Master Files pages
import Customer from '@/pages/Home/MasterFiles/ProfileMaster/CustomerPage';
import ShipperConsignee from '@/pages/Home/MasterFiles/ProfileMaster/ShipperConsignee';
import Creditor from '@/pages/Home/MasterFiles/ProfileMaster/CreditorPage';
import Supplier from '@/pages/Home/MasterFiles/ProfileMaster/SupplierPage';
import Employee from '@/pages/Home/MasterFiles/ProfileMaster/Employee';

// import Vehicle from '@/pages/Home/MasterFiles/OperationMaster/VehiclePage' // replaced by VehicleV2
import ItemType from '@/pages/Home/MasterFiles/OperationMaster/ItemType'; // added
import VehicleV2 from '@/pages/Home/MasterFiles/OperationMaster/VehiclePageV2';
import VehicleCategory from '@/pages/Home/MasterFiles/OperationMaster/VehicleCategory';
import CargoType from '@/pages/Home/MasterFiles/OperationMaster/CargoType';
import ContHandlingType from '@/pages/Home/MasterFiles/OperationMaster/ContHandlingType';
import Destination from '@/pages/Home/MasterFiles/OperationMaster/Destination';
import Zone from '@/pages/Home/MasterFiles/OperationMaster/Zone';
import Port from '@/pages/Home/MasterFiles/OperationMaster/Port';
import VehicleOwnership from '@/pages/Home/MasterFiles/OperationMaster/VehicleOwnership';
import EMSPartType from '@/pages/Home/MasterFiles/OperationMaster/EMSPartType';
import WarehouseProduct from '@/pages/Home/MasterFiles/OperationMaster/WarehouseProduct';
import Commodity from '@/pages/Home/MasterFiles/OperationMaster/Commodity';
import GmapTest from '@/pages/Home/MasterFiles/OperationMaster/GmapTest';
import DefaultCharges from '@/pages/Home/MasterFiles/OperationMaster/DefaultCharges';
import ContainerType from '@/pages/Home/MasterFiles/OperationMaster/ContainerType';
import ServiceCode from '@/pages/Home/MasterFiles/OperationMaster/ServiceCode';
import ContDeliveryType from '@/pages/Home/MasterFiles/OperationMaster/ContDeliveryType';
import Company from '@/pages/Home/MasterFiles/CommonMaster/Company';
import Document from '@/pages/Home/MasterFiles/CommonMaster/Document';
import SalesServices from '@/pages/Home/MasterFiles/CommonMaster/SalesServices';
import Country from '@/pages/Home/MasterFiles/CommonMaster/Country';
import ExchangeRate from '@/pages/Home/MasterFiles/CommonMaster/ExchangeRate';
import Station from '@/pages/Home/MasterFiles/CommonMaster/Station';
import StatusGroup from '@/pages/Home/MasterFiles/CommonMaster/StatusGroup';
import StatusCode from '@/pages/Home/MasterFiles/CommonMaster/StatusCode';
import VehicleTeam from '@/pages/Home/MasterFiles/OperationMaster/VehicleTeam';
import StatusListCategory from '@/pages/Home/MasterFiles/CommonMaster/StatusListCategory';

import TruckingRate from '@/pages/Home/MasterFiles/RatesMaster/TruckingRate';
import TariffRate from '@/pages/Home/MasterFiles/RatesMaster/TariffRate';
import ContainerRate from '@/pages/Home/MasterFiles/RatesMaster/ContainerRate';
import HaulageRate from '@/pages/Home/MasterFiles/RatesMaster/HaulageRate';
import BillRateOthers from '@/pages/Home/MasterFiles/RatesMaster/BillRateOthers.vue';
// import ExcelTest from '@/pages/Home/MasterFiles/OperationMaster/ExcelTest'
// import MasterCounting from '@/pages/Home/MasterFiles/OperationMaster/MasterCounting'
// import ISTGenerated from '@/pages/Home/MasterFiles/OperationMaster/ISTGenerated'

//#region Accounting Master
import Bank from '@/pages/Home/MasterFiles/AccountingMaster/Bank';
import ChargeCode from '@/pages/Home/MasterFiles/AccountingMaster/ChargeCode';
import GLMaster from './pages/Home/MasterFiles/AccountingMaster/GLMaster.vue';
import TransactionGroup from '@/pages/Home/MasterFiles/AccountingMaster/TransactionGroup';
//#endregion

//#region Reports pages
import DeliveryNoteReport from '@/pages/Reports/DeliveryNoteReport';
import JobSheetReport from '@/pages/Reports/JobSheetReport';
//#endregion

//#region ReportsV2 pages
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';
import BookingConfirmationV2 from '@/pages/ReportsV2/BookingConfirmation';
import ContainerAttachmentV2 from '@/pages/ReportsV2/ContainerAttachment';
import JobSheetV2 from '@/pages/ReportsV2/JobSheet';
import ExportMonitoringLog from '@/pages/ReportsV2/ExportMonitoringLog';
import LetterOfIndemnity from '@/pages/ReportsV2/LetterOfIndemnity';
import ShippingNoteReport from '@/pages/ReportsV2/ShippingNoteReport';
import IIDIED from '@/pages/ReportsV2/IIDIED';
import CreateLOI from '@/pages/ReportsV2/CreateLOI';
import DeliveryNoteReportV2 from '@/pages/ReportsV2/DeliveryNoteReport';
import JobSummary from '@/pages/ReportsV2/JobSummary';
// import HaulageJobReport from '@/pages/ReportsV2/HaulageJobReport';
import SMKJobForms from '@/pages/ReportsV2/SMKJobForms';
//#endregion

import PrintJobDocuments from '@/pages/PrintJobDocuments';

import PrivacyPolicy from '@/pages/PrivacyPolicy/PrivacyPolicyPage';
//#region Financial pages
import FinancialsHome from '@/pages/Home/Financials/FinancialsHome';
import JobCharges from '@/pages/Home/Financials/JobCharges';
import PrintJobCharges from '@/pages/Home/Financials/PrintJobCharges';
import Payment from '@/pages/Home/Financials/Payment';
import PrintPaymentVoucher from '@/pages/Home/Financials/PrintPaymentVoucher';
import FINARReport from '@/pages/Home/Financials/FINAR/FINARReport';
import StatementOfAccounts from '@/pages/Home/Financials/FINAR/StatementOfAccounts';
import Journal from './pages/Home/Financials/FINAR/Journal.vue';
import Invoice from '@/pages/Home/Financials/FINAR/Invoice';
import PrintARInvoiceDebitNote from '@/pages/Home/Financials/FINAR/PrintARInvoiceDebitNote';
import CreditNote from '@/pages/Home/Financials/FINAR/CreditNote';
import PrintCreditNote from '@/pages/Home/Financials/FINAR/PrintCreditNote';
import HQConsolidatedProfitLoss from '@/pages/Home/Financials/FINGL/HQConsolidated/HQConsolidatedProfitLoss';
import HQProfitLossDrillThrough from '@/pages/Home/DrillThroughPages/HQProfitLossDrillThrough';
import HQConsolidatedEnquiries from '@/pages/Home/Financials/FINGL/HQConsolidated/HQConsolidatedEnquiries';
import Enquiries from '@/pages/Home/Financials/FINGL/Enquiries';
import EInovice from '@/pages/Home/Financials/eInvoice';
import BankReconciliation from '@/pages/Home/Financials/BankReconciliation';
import PrintBankReconciliation from '@/pages/Home/Financials/PrintBankReconciliation';
import RefundNote from '@/pages/Home/Financials/FINADJ/RefundNote';
import BatchImport from '@/pages/Home/Financials/FINAR/BatchImport';
import Receipt from '@/pages/Home/Financials/FINAR/Receipt';
import MiscReceipt from '@/pages/Home/Financials/FINAR/MiscReceipt';
import PrintReceipt from './pages/Home/Financials/FINAR/PrintReceipt.vue';
import AcknowledgementLetter from './pages/Home/Financials/FINAR/AcknowledgementLetter.vue';
import PrintAcknowledgementLetter from './pages/Home/Financials/FINAR/PrintAcknowledgementLetter.vue';
import APInvoice from './pages/Home/Financials/APInvoice.vue';
import APInvoiceImport from './pages/Home/Financials/APInvoiceImport.vue';
import FINGLJournal from '@/pages/Home/Financials/FINGL/Journal';
import PrintFINGLJournal from '@/pages/Home/Financials/FINGL/PrintJournal';
import MonthEnd from '@/pages/Home/Financials/MonthEnd';
import Validation from '@/pages/Home/Financials/FINGL/Validation'
import NewYearGen from './pages/Home/Financials/FINGL/NewYearGen.vue';
//#endregion
import UtilitiesHome from '@/pages/Home/Utilities/UtilitiesHome';

import TradingHome from '@/pages/Home/Trading/TradingHome';

import PageNotFound from '@/pages/PageNotFound';
import BroadcastMessage from '@/pages/BroadcastMessage';

import PaymentStatus from '@/pages/PaymentStatus';

import DateTime from '@/js/dateTime.js';
import SubMenu from '@/js/submenu.js';
import Bus from '@/js/eventBus.js';
import Alert from '@/js/alert.js';
import ChartColors from '@/js/chartColors.js';
import Signal from '@/js/signalRHub.js';
import ConvertFile from '@/js/convertFile.js';
import excel from '@/js/excel.js';
import db from '@/js/db.js';
import analytics from './js/analytics';

//#region Sample pages
import NewSample from '@/componentsSample/NewSamplePage';
import SampleHome from '@/componentsSample/SampleHome';
import InputSample from '@/componentsSample/InputSample';
import DropdownSample from '@/componentsSample/DropdownSample';
import DateTimePickerSample from '@/componentsSample/DateTimePickerSample';
import BackgroundSample from '@/componentsSample/BackgroundSample';
//#endregion

//#region Freight Forwarding UI pages
import FREUI from '@/pages/Home/Logistics/FREUI';
//#endregion

//#region All Components
import Input from '@/components/Input.vue';
import Input2 from '@/components/v2testComponent/InputV2.vue';
import Dropdown from '@/components/Dropdown.vue';
import DropdownV2 from '@/components/v2testComponent/DropdownV2.vue';
import DropdownSearch from '@/components/v2testComponent/DropdownSearch.vue';
import InputQuery from '@/components/InputQuery.vue';
import InputQueryV2 from '@/components/v2testComponent/InputQueryV2.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import DateTimePickerV2 from '@/components/v2testComponent/DateTimePickerV2.vue';
import GanttChartV2 from '@/components/charts/GanttChartV2.vue';
import GanttChartV3 from '@/components/charts/GanttChartV3.vue';
import Loader from '@/components/Loader.vue';
import CheckBox from '@/components/CheckBox.vue';
import CheckBoxV2 from '@/components/v2testComponent/CheckBoxV2.vue';
import CheckBoxSet from '@/components/v2testComponent/CheckBoxSet.vue';
import Tabulator from '@/components/Tabulator.vue';
import RadioButton from '@/components/RadioButton.vue';
import RadioButtonV2 from '@/components/v2testComponent/RadioButtonV2.vue';
import RadioButtonSet from '@/components/v2testComponent/RadioButtonSet.vue';
import Tooltip from '@/components/Tooltip.vue';
import TableBox from '@/components/v2testComponent/TableBox.vue';
import PopupV2 from '@/components/v2testComponent/PopupV2.vue';
import DocStatusUpdate from '@/components/DocStatusUpdate.vue';
import AddressForm from '@/components/AddressForm.vue';
import AddressFormV2 from '@/components/v2testComponent/AddressFormV2.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import BigLegends from '@/components/BigLegends.vue';
import Menus from '@/components/Menus.vue';
import RightMenu from '@/components/RightMenu.vue';
import PopupEntry from '@/components/PopupEntry.vue';
import EntryPopup from '@/components/EntryPopup.vue';
import Filters from '@/components/Filters.vue';
import Tab from '@/components/Tab.vue';
import BoxContainer from '@/components/BoxContainer.vue';
import ContextMenu from '@/components/ContextMenu.vue';
import CustomMap from '@/components/CustomMap.vue';
import CustomMapV2 from '@/components/CustomMapV2.vue';
import Carousel from '@/components/Carousel.vue';
import ButtonFilter from '@/components/ButtonFilter.vue';
import Verification from '@/components/Verification.vue';
import AssignV3 from '@/components/VehicleTracker/AssignV3.vue';
import Validator from '@/components/VehicleTracker/ValidatorV2.vue';
import TripDetailContainer from '@/components/TripDetailContainer.vue';
import HMSUpdateStatusTask from '@/components/HMSUpdateStatusTask.vue';
import EmailInput from '@/components/EmailInput.vue';

import DesignerV2 from '@/components/reportDesigner/DesignerV2.vue';
import DesignerV3 from '@/components/reportDesigner/DesignerV3.vue';
import UpdateStatusTask from '@/components/HMSUpdateStatusTask.vue';
import ItemListing from '@/components/ItemListing.vue';
import JobPageCargoInfoPopup from '@/components/popupComponents/JobPageCargoInfoPopup.vue';

import PieChartV2 from '@/components/charts/PieChartV2.vue';
import BarLineChartV2 from '@/components/charts/BarLineChartV2.vue';
import ForeignCurrency from '@/components/ForeignCurrency.vue';
import PrintWorkOrder from './pages/Home/Workshop/PrintWorkOrder.vue';
import PurchaseOrder from './pages/Home/Financials/PurchaseOrder.vue';

import TemplateMapping from '@/components/TemplateMapping.vue';
import PrintStockBalance from './pages/Home/Workshop/PrintStockBalance.vue';
import PrintPurchaseOrder from './pages/Home/Financials/PrintPurchaseOrder.vue';
import PurchaseRequisition from './pages/Home/Financials/PurchaseRequisition.vue';
import PrintPurchaseRequisition from './pages/Home/Financials/PrintPurchaseRequisition.vue';
import SSTReturn from './pages/Home/Financials/FINGL/SSTReturn.vue';
import PrintSSTReturn from './pages/Home/Financials/FINGL/PrintSSTReturn.vue';
//#endregion

//#region Global Components
Vue.component('Input', Input2);
// Vue.component('Input2', Input2);
Vue.component('Dropdown', DropdownV2);
Vue.component('DropdownSearch', DropdownSearch);
// Vue.component('Dropdown2', DropdownV2);
Vue.component('InputQuery', InputQueryV2);
// Vue.component('InputQuery2', InputQueryV2);
Vue.component('DateTimePicker', DateTimePickerV2);
// Vue.component('DateTimePicker2', DateTimePickerV2);
Vue.component('GanttChartV2', GanttChartV2);
Vue.component('GanttChartV3', GanttChartV3);
Vue.component('Loader', Loader);
Vue.component('CheckBox', CheckBox);
Vue.component('CheckBoxV2', CheckBoxV2);
Vue.component('CheckBoxSet', CheckBoxSet);
Vue.component('Tabulator', Tabulator);
Vue.component('RadioButton', RadioButton);
Vue.component('RadioButtonV2', RadioButtonV2);
Vue.component('RadioButtonSet', RadioButtonSet);
Vue.component('Tooltip', Tooltip);
Vue.component('RemarksBox', RemarksBox);
Vue.component('BigLegends', BigLegends);
Vue.component('TableBox', TableBox);
Vue.component('PopupV2', PopupV2);

Vue.component('DocStatusUpdate', DocStatusUpdate);

Vue.component('AddressForm', AddressForm);
Vue.component('AddressFormV2', AddressFormV2);

Vue.component('Menus', Menus);
Vue.component('RightMenu', RightMenu);
Vue.component('PopupEntry', PopupEntry);
Vue.component('EntryPopup', EntryPopup);
Vue.component('Filters', Filters);
Vue.component('Tab', Tab);
Vue.component('BoxContainer', BoxContainer);
Vue.component('ContextMenu', ContextMenu);
Vue.component('CustomMap', CustomMap);
Vue.component('CustomMapV2', CustomMapV2);
Vue.component('Carousel', Carousel);
Vue.component('ButtonFilter', ButtonFilter);
Vue.component('Verification', Verification);
Vue.component('AssignV3', AssignV3);
Vue.component('Validator', Validator);
Vue.component('HMSUpdateStatusTask', HMSUpdateStatusTask);
Vue.component('EmailInput', EmailInput);

Vue.component('DesignerV2', DesignerV2);
Vue.component('DesignerV3', DesignerV3);
Vue.component('TripDetailContainer', TripDetailContainer);
Vue.component('UpdateStatusTask', UpdateStatusTask);
Vue.component('ItemListing', ItemListing);
Vue.component('JobPageCargoInfoPopup', JobPageCargoInfoPopup);

Vue.component('PieChart', PieChartV2);
Vue.component('BarLineChart', BarLineChartV2);

Vue.component('ForeignCurrency', ForeignCurrency);
Vue.component('TemplateMapping', TemplateMapping);
//#endregion

Vue.config.productionTip = false;
Vue.use(Router);
Vue.use(Cookies);

const router = new Router({
  routes: [
    { path: '/', component: LoginPage, meta: { title: 'Login' } },
    // { path: '/TestPage', component: TestPage, meta: { title: 'Test Page' } }, // used in the past to diagnose "No such host is known" issues, no longer needed, uncomment if you wish to diagnose another issue
    { path: '/Hello', component: HelloWorld, meta: { title: 'Hello World' } },
    { path: '/DataRetrieval', component: DocAIDataRetrievePage, meta: { title: 'Data Retrieval' } },
    { path: '/KnowledgeBase/Edit', component: KnowledgeBase, meta: { title: 'DSM Knowledge Base' } },
    {
      path: '/Reports',
      component: ReportsHome,
      meta: { title: 'Reports Home Page' },
      children: [
        {
          path: 'Booking Confirmation/:jobno',
          component: BookingConfirmation,
          meta: { title: 'Booking Confirmation Letter Page' },
        },
        // { path: 'Shipping Note Report', component: ShippingNoteReport, meta: { title: 'Shipping Note Report Page' } },
        // { path: 'Container Attachment/:jobno', component: ContainerAttachment, meta: { title: 'Container Attachment' } },
        { path: ':ReportName', component: DefaultReport, meta: { title: 'Report Page' } },
        { path: ':ReportName/:refNo', component: DefaultReport, meta: { title: 'Report Page' } },
      ],
    },
    //#region ReportsV2
    { path: '/:user?/ReportsV2', component: ReportsHomeV2, meta: { title: 'Reports' } },
    {
      path: '/:user?/ReportsV2/Container Attachment',
      component: ContainerAttachmentV2,
      meta: { title: 'Container Attachment Report Page' },
    },
    {
      path: '/:user?/ReportsV2/Booking Confirmation',
      component: BookingConfirmationV2,
      meta: { title: 'Booking Confirmation Letter Page' },
    },
    { path: '/:user?/ReportsV2/Job Sheet', component: JobSheetV2, meta: { title: 'Job Sheet Report Page' } },
    {
      path: '/:user?/ReportsV2/Export Monitoring Log',
      component: ExportMonitoringLog,
      meta: { title: 'Export Monitoring Log' },
    },
    {
      path: '/:user?/ReportsV2/Letter of Indemnity',
      component: LetterOfIndemnity,
      meta: { title: 'Letter of Indemnity Page' },
    },
    {
      path: '/:user?/ReportsV2/Shipping Note Report',
      component: ShippingNoteReport,
      meta: { title: 'Shipping Note Report Page' },
    },
    { path: '/:user?/ReportsV2/IID IED', component: IIDIED, meta: { title: 'IID/IED Page' } },
    { path: '/:user?/ReportsV2/Create LOI', component: CreateLOI, meta: { title: 'Create LOI' } },
    { path: '/:user?/ReportsV2/Delivery Note', component: DeliveryNoteReportV2, meta: { title: 'Delivery Note' } },
    { path: '/:user?/ReportsV2/Job Summary', component: JobSummary, meta: { title: 'Job Summary Page' } },
    // { path: '/:user?/ReportsV2/Haulage Report', component: HaulageJobReport, meta: { title: 'Haulage Job Report' } },
    // { path: '/:user?/ReportsV2/SMK Job Forms', component: SMKJobForms, meta: { title: 'SMK Job Forms' } },

    {
      path: '/RedirectConfigCode/:configCode?',
      component: RedirectConfigCode,
      meta: { title: 'Redirect Config Code' },
    },

    //#endregion
    //#region Home
    {
      path: '/Home/:user',
      component: HomePage,
      meta: { title: 'Home Page' },
      children: [
        { path: '/', component: HomeIndex, meta: { title: 'Home Page' } },

        { path: 'About', component: HomeAbout, meta: { title: 'ELMS - Home Page - About' } },
        { path: 'Contact', component: HomeContact, meta: { title: 'ELMS - Home Page - Contact' } },
        { path: 'Status/:jobno?', component: StatusPage, meta: { title: 'ELMS - TAS & KPI' } },
        { path: 'KnowledgeBase', component: KnowledgeBaseView, meta: { title: 'Knowledge Base' } },

        //#region Dashboard Pages
        // Include Dashboard Home here
        { path: 'Dashboard/Haulage Capacity', component: HaulageDashboardV2, meta: { title: 'Haulage Capacity' } },
        // { path: 'Dashboard/Haulage Capacity V2', component: HaulageDashboardV2, meta: { title: 'Haulage Capacity V2' } },
        { path: 'Dashboard/Task Schedule', component: TaskSchedulePageV2, meta: { title: 'Task Schedule' } },
        // { path: 'Dashboard/Task Schedule V2', component: TaskSchedulePageV2, meta: { title: 'Task Schedule V2' } },
        { path: 'Dashboard/Job Milestones', component: JobMilestone, meta: { title: 'Job Milestones' } },
        {
          path: 'Dashboard/Container Throughput POL and POD',
          component: ContainerThroughputPOLPOD,
          meta: { title: 'Container Throughput by POL and POD' },
        },
        {
          path: 'Dashboard/LCL Throughput POL and POD',
          component: LCLThroughputPOLPOD,
          meta: { title: 'LCL Throughput by POL and POD' },
        },
        {
          path: 'Dashboard/LCL Throughput POL and POD/:drillThroughName',
          component: LCLDrillThrough,
          meta: { title: 'LCL Throughput by POL and POD (Drill Through)' },
        },
        {
          path: 'Dashboard/Container Throughput POL and POD/:drillThroughName',
          component: POLPODDrillThrough,
          meta: { title: 'Container Throughput by POL and POD (Drill Through)' },
        },
        {
          path: 'Dashboard/Container Throughput',
          component: ContainerThroughput,
          meta: { title: 'Container Throughput' },
        },
        {
          path: 'Dashboard/Container Throughput/:drillThroughName',
          component: ContainerThroughputDrillThrough,
          meta: { title: 'Container Throughput (Drill Through)' },
        },
        { path: 'Dashboard/Sales Analysis', component: SalesDashboard, meta: { title: 'Sales Analysis' } },
        {
          path: 'Dashboard/Sales Analysis/:drillThroughName',
          component: SalesAnalysisDrillThrough,
          meta: { title: 'Sales Analysis' },
        },
        { path: 'Dashboard/Haulage Revenue', component: HaulageRevenueDashboard, meta: { title: 'Haulage Revenue' } },
        {
          path: 'Dashboard/Haulage Revenue/:drillThroughName',
          component: HaulageRevenueDrillThrough,
          meta: { title: 'Haulage Revenue' },
        },
        {
          path: 'Dashboard/Haulage Revenue by PM & Driver',
          component: HaulageRevenueByPMDriver,
          meta: { title: 'Haulage Revenue by PM & Driver' },
        },
        {
          path: 'Dashboard/Haulage Revenue by PM & Driver/:drillThroughName',
          component: HaulageRevenueByPMDriverDrillThrough,
          meta: { title: 'Haulage Revenue by PM & Driver' },
        },
        { path: 'Dashboard/Profit & Loss', component: ProfitLossDashboard, meta: { title: 'Profit & Loss' } },
        {
          path: 'Dashboard/Profit & Loss/:drillThroughName',
          component: ProfitLossDrillThrough,
          meta: { title: 'Profit & Loss (Drill Through)' },
        },
        {
          path: 'Dashboard/Delivery & Collection KPI',
          component: DeliveryCollectionKPI,
          meta: { title: 'Delivery & Collection KPI' },
        },
        {
          path: 'Dashboard/Delivery & Collection KPI/:drillThroughName',
          component: DelColKPIDrillThrough,
          meta: { title: 'Delivery & Collection KPI (Drill Through)' },
        },
        { path: 'Dashboard/DocumentAi', component: DocumentAi, meta: { title: 'Document AI' } },
        { path: 'Dashboard/Document Approval', component: DocumentApproval, meta: { title: 'Document Approval' } },
        {
          path: 'Dashboard/Document Approval Creator',
          component: DocumentApprovalCreator,
          meta: { title: 'Document Approval Creator' },
        },
        { path: 'Dashboard/Job Costing', component: JobCosting, meta: { title: 'Job Costing' } },
        {
          path: 'Dashboard/Job Costing Drill Through',
          component: JobCostingDrillThrough,
          meta: { title: 'Job Costing (Drill Through)' },
        },
        { path: 'Dashboard/Equipment Expenses', component: EquipmentExpenses, meta: { title: 'Equipment Expenses' } },
        {
          path: 'Dashboard/Equipment Expenses/:drillThroughName',
          component: EquipmentExpensesDrillThrough,
          meta: { title: 'Equipment Expenses (Drill Through)' },
        },
        { path: 'Dashboard/Equipment Downtime', component: EquipmentDowntime, meta: { title: 'Equipment Downtime' } },
        {
          path: 'Dashboard/Equipment Downtime/:drillThroughName',
          component: EquipmentDowntimeDrillThrough,
          meta: { title: 'Equipment Downtime (Drill Through)' },
        },
        {
          path: 'Dashboard/Turnaround Analysis',
          component: TurnaroundAnalysis,
          meta: { title: 'Turnaround Analysis' },
        },
        {
          path: 'Dashboard/Turnaround Analysis/:drillThroughName',
          component: TurnaroundAnalysisDrillThrough,
          meta: { title: 'Turnaround Analysis (Drill Through)' },
        },
        //#endregion

        //#region Freight Forwarding Pages
        { path: 'FreightForwarding/Delivery Notes', component: DeliveryNotes, meta: { title: 'Delivery Notes' } },
        {
          path: 'FreightForwarding/Delivery Notes/:action/:jobNo',
          component: DeliveryNotes,
          meta: { title: 'Delivery Notes' },
        },
        { path: 'FreightForwarding/eDeliveryNotes', component: eDeliveryNotes, meta: { title: 'e-Delivery Notes' } },
        { path: 'FreightForwarding/Import Job', component: Job, meta: { title: 'Import Job' } },
        { path: 'FreightForwarding/Export Job', component: Job, meta: { title: 'Export Job' } },
        { path: 'FreightForwarding/ROT', component: ROT, meta: { title: 'ROT' } },
        { path: 'FreightForwarding/eROT', component: eROT, meta: { title: 'eROT' } },
        {
          path: 'FreightForwarding/Freight Forwarding Report',
          component: FreightForwardingReport,
          meta: { title: 'Freight Forwarding Report' },
        },
        { path: 'FreightForwarding/Import CIPL', component: ImportCIPL, meta: { title: 'Import CIPL to SMK' } },
        { path: 'FreightForwarding/Freight Booking', component: FreightBooking, meta: { title: 'Freight Booking' } },
        {
          path: 'FreightForwarding/Print Booking Confirmation',
          component: PrintBookingConfirmation,
          meta: { title: 'Print Booking Confirmation' },
        },
        {
          path: 'FreightForwarding/Print Delivery Notes',
          component: PrintDeliveryNotes,
          meta: { title: 'Print Delivery Notes' },
        },
        {
          path: 'FreightForwarding/Print House BL',
          component: PrintHouseBL,
          meta: { title: 'Print House BL' },
        },
        { path: 'FreightForwarding/Default Charges', component: DefaultCharges, meta: { title: 'Default Charges' } },
        { path: 'FreightForwarding/Print Notice', component: PrintNotice, meta: { title: 'Print Notice' } },
        //#endregion

        //#region Haulage Pages Route
        // Include Haulage Home here
        { path: 'Haulage/Vehicle Schedule', component: VehicleScheduleV4, meta: { title: 'Vehicle Schedule' } },
        { path: 'Haulage/Vehicle Tracking', component: VehicleTrackingV3, meta: { title: 'Vehicle Tracking' } },
        { path: 'Haulage/Haulage Capacity', component: HaulageCapacity, meta: { title: 'Haulage Capacity' } },
        { path: 'Haulage/Haulage Job', component: HaulageJob, meta: { title: 'Haulage Job' } },
        { path: 'Haulage/Haulage Report', component: HaulageReport, meta: { title: 'Haulage Report' } },
        { path: 'Haulage/Movement History', component: MovementHistory, meta: { title: 'Movement History' } },
        { path: 'Haulage/Movement Update', component: MovementUpdate, meta: { title: 'Movement Update' } },
        { path: 'Haulage/Consignment', component: Consignment, meta: { title: 'Consignment' } },
        //#endregion

        //#region Trucking Pages
        { path: 'Trucking/Batch Booking', component: BatchBooking, meta: { title: 'Batch Booking' } },
        { path: 'Trucking/Batch Order', component: BatchOrder, meta: { title: 'Batch Order' } },
        { path: 'Trucking/Vehicle Schedule', component: TruckingSchedule, meta: { title: 'Vehicle Schedule' } },
        { path: 'Trucking/Trip Report', component: TripReport, meta: { title: 'Trip Report' } },
        { path: 'Trucking/Plan And Assign', component: PlanAndAssign, meta: { title: 'Plan And Assign' } },
        { path: 'Trucking/Trucking Job', component: TruckingJob, meta: { title: 'Trucking Job' } },
        { path: 'Trucking/Trucking Report', component: TruckingReport, meta: { title: 'Trucking Report' } },
        { path: 'Trucking/Movement Update', component: TruckingMovementUpdate, meta: { title: 'Movement Update' } },
        // { path: 'Trucking/Trucking Job Details', component: TruckingJobDetails, meta: { title: 'Trucking Job Details' } },
        // { path: 'Trucking/Trucking Job Test', component: TruckingJobTest, meta: { title: 'Trucking Job Testing' } },
        //#endregion

        // Trucking Pages Route

        //#region workshop pages
        { path: 'Workshop/WorkshopJob', component: WorkshopJob, meta: { title: 'Workshop Job' } },
        { path: 'Workshop/PrintWorkOrder', component: PrintWorkOrder, meta: { title: 'Print Work Order' } },
        { path: 'Workshop/EquipmentSchedule', component: EquipmentSchedule, meta: { title: 'Equipment Schedule' } },
        { path: 'Workshop/PartInventory', component: PartInventory, meta: { title: 'Part Inventory' } },
        { path: 'Workshop/PrintStockBalance', component: PrintStockBalance, meta: { title: 'Print Stock Balance' } },
        { path: 'Workshop/Equipment Report', component: EquipmentReport, meta: { title: 'Equipment Report' } },
        { path: 'Workshop/Policy Alerts', component: PolicyAlerts, meta: { title: 'PolicyAlerts' } },
        //#endregion

        //#region Settings Pages
        // Include Settings Home here
        { path: 'Settings/User Management', component: UserManagement, meta: { title: 'User Management' } },
        { path: 'Settings/Role Management', component: RoleManagement, meta: { title: 'Role Management' } },
        { path: 'Settings/User Options', component: UserOptions, meta: { title: 'User Options' } },
        { path: 'Settings/Report Designer', component: ReportDesignerV2, meta: { title: 'Report Designer' } },
        { path: 'Settings/Report Designer V2', component: DesignerV2Page, meta: { title: 'Report Designer V2' } },
        { path: 'Settings/Report Designer V3', component: DesignerV3Page, meta: { title: 'Report Designer V3' } },
        // { path: 'Settings/Report Designer', component: ReportDesigner, meta: { title: 'Report Designer' } },
        {
          path: 'Settings/SMK Message Tracking',
          component: SMKMessageTracking,
          meta: { title: 'SMK Message Tracking' },
        },
        { path: 'Settings/Broadcast Message', component: BroadcastMessage, meta: { title: 'Broadcast Message' } },
        //#endregion

        //#region Logistics Pages
        { path: 'Logistics', component: LogisticsHome, meta: { title: 'Logistics' } },
        { path: 'Logistics/FRE', component: FRE, meta: { title: 'Logistics (FRE)' } },
        { path: 'Logistics/FREUI', component: FREUI, meta: { title: 'FREUI' } },
        { path: 'Logistics/FMS', component: FMS, meta: { title: 'Logistics (FMS)' } },
        { path: 'Logistics/HMS', component: HMS, meta: { title: 'Logistics (HMS)' } },
        { path: 'Logistics/WMS', component: WMS, meta: { title: 'Logistics (HMS)' } },
        { path: 'Logistics/CON', component: CON, meta: { title: 'Logistics (CON)' } },
        { path: 'Logistics/EMS', component: EMS, meta: { title: 'Logistics (EMS)' } },
        // { path: 'Logistics/CUSTPROF', component: CUSTPROF, meta: { title: 'Customer Profile (CUSTPROF)' } },
        { path: 'Logistics/crunchie1', component: CRUNCHIE1, meta: { title: 'Crunchie Test Page 1' } },
        { path: 'Logistics/crunchie2', component: CRUNCHIE2, meta: { title: 'Crunchie Test Page 2' } },
        //#endregion

        //#region Master Files Pages
        { path: 'MasterFiles/ProfileMaster/Customer', component: Customer, meta: { title: 'Customer' } },
        {
          path: 'MasterFiles/ProfileMaster/ShipperConsignee',
          component: ShipperConsignee,
          meta: { title: 'Shipper/Consignee' },
        },
        { path: 'MasterFiles/ProfileMaster/Creditor', component: Creditor, meta: { title: 'Creditor' } },
        { path: 'MasterFiles/ProfileMaster/Supplier', component: Supplier, meta: { title: 'Supplier' } },
        { path: 'MasterFiles/ProfileMaster/Employee', component: Employee, meta: { title: 'Employee' } },
        { path: 'MasterFiles/OperationMaster/Vehicle', component: VehicleV2, meta: { title: 'Vehicle' } },
        {
          path: 'MasterFiles/OperationMaster/VehicleCategory',
          component: VehicleCategory,
          meta: { title: 'VehicleCategory' },
        },
        { path: 'MasterFiles/OperationMaster/CargoType', component: CargoType, meta: { title: 'CargoType' } },
        {
          path: 'MasterFiles/OperationMaster/ContHandlingType',
          component: ContHandlingType,
          meta: { title: 'ContHandlingType' },
        },
        { path: 'MasterFiles/OperationMaster/Destination', component: Destination, meta: { title: 'Destination' } },
        { path: 'MasterFiles/OperationMaster/Zone', component: Zone, meta: { title: 'Zone' } },
        { path: 'MasterFiles/OperationMaster/Port', component: Port, meta: { title: 'Port' } },
        {
          path: 'MasterFiles/OperationMaster/VehicleOwnership',
          component: VehicleOwnership,
          meta: { title: 'VehicleOwnership' },
        },
        {
          path: 'MasterFiles/OperationMaster/VehicleTeam',
          component: VehicleTeam,
          meta: { title: 'VehicleTeam' },
        },
        { path: 'MasterFiles/OperationMaster/EMSPartType', component: EMSPartType, meta: { title: 'EMSPartType' } },
        {
          path: 'MasterFiles/OperationMaster/WarehouseProduct',
          component: WarehouseProduct,
          meta: { title: 'Warehouse Product' },
        },
        { path: 'MasterFiles/OperationMaster/Commodity', component: Commodity, meta: { title: 'Commodity' } },
        { path: 'MasterFiles/OperationMaster/GmapTest', component: GmapTest, meta: { title: 'GmapTest Page' } },
        {
          path: 'MasterFiles/OperationMaster/ContainerType',
          component: ContainerType,
          meta: { title: 'ContainerType' },
        },
        { path: 'MasterFiles/OperationMaster/ServiceCode', component: ServiceCode, meta: { title: 'ServiceCode' } },
        {
          path: 'MasterFiles/OperationMaster/ContDeliveryType',
          component: ContDeliveryType,
          meta: { title: 'ContDeliveryType' },
        },
        {
          path: 'MasterFiles/OperationMaster/ItemType',
          component: ItemType,
          meta: { title: 'ItemType' },
        },
        { path: 'MasterFiles/AccountingMaster/Bank', component: Bank, meta: { title: 'Bank' } },
        { path: 'MasterFiles/AccountingMaster/ChargeCode', component: ChargeCode, meta: { title: 'ChargeCode' } },
        { path: 'MasterFiles/AccountingMaster/GLMaster', component: GLMaster, meta: { title: 'GLMaster' } },
        {
          path: 'MasterFiles/AccountingMaster/TransactionGroup',
          component: TransactionGroup,
          meta: { title: 'TransactionGroup' },
        },
        { path: 'MasterFiles/CommonMaster/Company', component: Company, meta: { title: 'Company' } },
        { path: 'MasterFiles/CommonMaster/Country', component: Country, meta: { title: 'Country' } },
        { path: 'MasterFiles/CommonMaster/Document', component: Document, meta: { title: 'Document' } },
        { path: 'MasterFiles/CommonMaster/ExchangeRate', component: ExchangeRate, meta: { title: 'ExchangeRate' } },
        { path: 'MasterFiles/CommonMaster/Station', component: Station, meta: { title: 'Station' } },
        { path: 'MasterFiles/CommonMaster/Sales Team', component: SalesServices, meta: { title: 'Sales Team' } },
        { path: 'MasterFiles/CommonMaster/Service Team', component: SalesServices, meta: { title: 'Service Team' } },
        { path: 'MasterFiles/CommonMaster/StatusGroup', component: StatusGroup, meta: { title: 'StatusGroup' } },
        {
          path: 'MasterFiles/CommonMaster/StatusListCategory',
          component: StatusListCategory,
          meta: { title: 'StatusListCategory' },
        },
        {
          path: 'MasterFiles/RatesMaster/BillRateOthers',
          component: BillRateOthers,
          meta: { title: 'Bill Rate Others' },
        },
        { path: 'MasterFiles/CommonMaster/StatusGroup', component: StatusGroup, meta: { title: 'StatusGroup' } },
        { path: 'MasterFiles/CommonMaster/StatusCode', component: StatusCode, meta: { title: 'StatusCode' } },

        { path: 'MasterFiles/RatesMaster/TruckingRate', component: TruckingRate, meta: { title: 'Trucking Rate' } },
        { path: 'MasterFiles/RatesMaster/TariffRate', component: TariffRate, meta: { title: 'TariffRate' } },
        { path: 'MasterFiles/RatesMaster/ContainerRate', component: ContainerRate, meta: { title: 'Container Rate' } },
        { path: 'MasterFiles/RatesMaster/HaulageRate', component: HaulageRate, meta: { title: 'Haulage Rates' } },

        //#endregion

        //#region Financials Pages
        { path: 'FINPayment/Job Charges', component: JobCharges, meta: { title: 'Job Charges' } },
        { path: 'FINPayment/Print Job Charges', component: PrintJobCharges, meta: { title: 'Print Job Charges' } },
        { path: 'FINPayment/Payment', component: Payment, meta: { title: 'Payment' } },
        {
          path: 'FINPayment/PurchaseRequisition',
          component: PurchaseRequisition,
          meta: { title: 'Purchase Requisition' },
        },
        {
          path: 'FINPayment/PrintPurchaseRequisition',
          component: PrintPurchaseRequisition,
          meta: { title: 'Print Purchase Requisition' },
        },
        { path: 'FINPayment/PurchaseOrder', component: PurchaseOrder, meta: { title: 'Purchase Order' } },
        {
          path: 'FINPayment/PrintPurchaseOrder',
          component: PrintPurchaseOrder,
          meta: { title: 'Print Purchase Order' },
        },
        {
          path: 'FINPayment/Print Payment Voucher',
          component: PrintPaymentVoucher,
          meta: { title: 'Print Payment Voucher' },
        },
        {
          path: 'FINPayment/AP Invoice',
          component: APInvoice,
          meta: { title: 'AP Invoice' },
        },
        {
          path: 'FINPayment/AP Credit Note',
          component: APInvoice,
          meta: { title: 'AP Credit Note' },
        },
        {
          path: 'FINPayment/AP Debit Note',
          component: APInvoice,
          meta: { title: 'AP Debit Note' },
        },
        {
          path: 'FINPayment/Import AP Invoice',
          component: APInvoiceImport,
          meta: { title: 'Import AP Invoice' },
        },
        { path: 'FINAR/Invoice', component: Invoice, meta: { title: 'Invoice' } },
        { path: 'FINAR/Debit Note', component: Invoice, meta: { title: 'Debit Note' } },
        { path: 'FINAR/Print Job Charges', component: PrintJobCharges, meta: { title: 'Print Job Charges' } },
        { path: 'FINAR/Job Charges', component: JobCharges, meta: { title: 'Job Charges' } },
        { path: 'FINAR/FINAR Report', component: FINARReport, meta: { title: 'FINAR Report' } },
        { path: 'FINAR/Statement Of Account', component: StatementOfAccounts, meta: { title: 'Statement Of Account' } },
        {
          path: 'FINAR/Acknowledgement Letter',
          component: AcknowledgementLetter,
          meta: { title: 'Acknowledgement Letter' },
        },
        {
          path: 'FINAR/Print Acknowledgement Letter',
          component: PrintAcknowledgementLetter,
          meta: { title: 'Print Acknowledgement Letter' },
        },
        { path: 'FINAR/Credit Note', component: CreditNote, meta: { title: 'Credit Note' } },
        { path: 'FINAR/eInvoice', component: EInovice, meta: { title: 'eInvoice' } },
        { path: 'FINAR/Print Invoice', component: PrintARInvoiceDebitNote, meta: { title: 'Print Invoice' } },
        { path: 'FINAR/Print Debit Note', component: PrintARInvoiceDebitNote, meta: { title: 'Print Debit Note' } },
        { path: 'FINAR/Print Credit Note', component: PrintCreditNote, meta: { title: 'Print Credit Note' } },
        {
          path: 'FINGL/HQConsolidated/HQConsolidatedProfitLoss',
          component: HQConsolidatedProfitLoss,
          meta: { title: 'HQ Consolidated Profit Loss' },
        },
        {
          path: 'FINGL/HQConsolidated/HQConsolidatedProfitLoss/:drillThroughName',
          component: HQProfitLossDrillThrough,
          meta: { title: 'HQ Profit & Loss (Drill Through)' },
        },
        {
          path: 'FINGL/HQConsolidated/HQConsolidatedEnquiries',
          component: HQConsolidatedEnquiries,
          meta: { title: 'HQ Consolidated Enquiries' },
        },
        { path: 'FINGL/Enquiries', component: Enquiries, meta: { title: 'Enquiries' } },
        { path: 'FINGL/SSTReturn', component: SSTReturn, meta: { title: 'SST Return (SST02)' } },
        { path: 'FINGL/PrintSSTReturn', component: PrintSSTReturn, meta: { title: 'Print SST Return (SST02)' } },
        {
          path: 'FINGL/Journal Entry',
          component: FINGLJournal,
          meta: { title: 'Journal Entry' },
        },
        {
          path: 'FINGL/Print Journal',
          component: PrintFINGLJournal,
          meta: { title: 'Print FINGL Journal' },
        },
        {
          path: 'FINGL/Generate New Year',
          component: NewYearGen,
          meta: { title: 'New Year Generation' },
        },
        {
          path: 'FINAccount/Bank Reconciliation',
          component: BankReconciliation,
          meta: { title: 'Bank Reconciliation' },
        },
        {
          path: 'FINAccount/Print Bank Reconciliation',
          component: PrintBankReconciliation,
          meta: { title: 'Print Bank Reconciliation' },
        },
        { path: 'FINADJ/Refund Note', component: RefundNote, meta: { title: 'Refund Note' } },
        { path: 'FINAR/Batch Import', component: BatchImport, meta: { title: 'Batch Import' } },
        { path: 'FINAR/Receipt', component: Receipt, meta: { title: 'Receipt' } },
        { path: 'FINAR/Print Receipt', component: PrintReceipt, meta: { title: 'Print Receipt' } },
        { path: 'FINAR/Misc Receipt', component: MiscReceipt, meta: { title: 'Misc Receipt' } },
        { path: 'FINAR/Print Misc Receipt', component: PrintReceipt, meta: { title: 'Print Misc Receipt' } },
        { path: 'FINAR/Journal', component: Journal, meta: { title: 'Journal' } },
        { path: 'FINAR/Month End', component: MonthEnd, meta: { title: 'Month End' }},
        { path: 'FINPayment/Month End', component: MonthEnd, meta: { title: 'Month End' }},
        { path: 'FINAccount/Month End', component: MonthEnd, meta: { title: 'Month End' }},
        { path: 'FINGL/Month End', component: MonthEnd, meta: { title: 'Month End' }},
        { path: 'FINGL/Validation', component: Validation, meta: { title: 'Validation' }},
        //#endregion

        { path: 'Utilities', component: UtilitiesHome, meta: { title: 'Utilities' } },

        { path: 'Trading', component: TradingHome, meta: { title: 'Trading' } },
      ],
    },
    //#endregion

    { path: '/GetDocInv', component: PrintJobDocuments, meta: { title: 'Invoice Documents' } },
    { path: '/GetDocInv/:userID/:config/:invno', component: PrintJobDocuments, meta: { title: 'Invoice Documents' } },
    { path: '/GetDocJob/:userID/:config/:jobno', component: PrintJobDocuments, meta: { title: 'Job Documents' } },

    { path: '/PrivacyPolicy/:app', component: PrivacyPolicy, meta: { title: 'Privacy Policy' } },

    { path: '/:user?/GenerateDN', component: DeliveryNoteReport, meta: { title: 'ELMS - DN Report' } },
    {
      path: '/:user?/GenerateDN/:userID/:config/:dnno',
      component: DeliveryNoteReport,
      meta: { title: 'ELMS - DN Report' },
    },
    {
      path: '/:user?/GenerateSMK/:userID/:config/:temptbl/:jobno/:base/:cocode',
      component: SMKJobForms,
      meta: { title: 'SMK Job Forms' },
    },

    { path: '/:user?/GenerateJS', component: JobSheetReport, meta: { title: 'ELMS - JS Report' } },
    {
      path: '/:user?/GenerateJS/:userID/:config/:jobNo',
      component: JobSheetReport,
      meta: { title: 'ELMS - JS Report' },
    },
    { path: '*', component: PageNotFound, meta: { title: 'Page Not Found' } },
    { path: '/NewSample', component: NewSample, meta: { title: 'New Sample Page' } },
    { path: '/PaymentStatus', component: PaymentStatus, meta: { title: 'Payment Status' } },
    //#region Sample pages
    {
      path: '/Sample/:user',
      component: SampleHome,
      meta: { title: 'Sample' },
      children: [
        { path: 'Input', component: InputSample, meta: { title: 'Sample - Input' } },
        { path: 'Dropdown', component: DropdownSample, meta: { title: 'Sample - Dropdown' } },
        { path: 'DateTimePicker', component: DateTimePickerSample, meta: { title: 'Sample - Datetime Picker' } },
        { path: 'Background', component: BackgroundSample, meta: { title: 'Sample - Background' } },
      ],
    },
    //#endregion
  ],
  mode: 'history',
});

//#region Prototypes
Vue.prototype.$dateTime = DateTime;
Vue.prototype.$subMenu = SubMenu;
Vue.prototype.$bus = Bus;
Vue.prototype.$alert = Alert; // Added warning message for deprecated
Vue.prototype.$chartColors = ChartColors;
Vue.prototype.$signal = Signal;
Vue.prototype.$convertFile = ConvertFile;

Vue.prototype.$app = App;
Vue.prototype.$getOverlayRoot = function () {
  return document.getElementById('app-overlay-root') || document.body;
};
Vue.prototype.$sleep = function (ms) {
  return new Promise((r) => setTimeout(r, ms));
};
Vue.prototype.$apiCallV2 = async function (url, data, method, errorObj = null) {
  const ignoredAPIForAnalytics = ['/Login/GetDetails', '/SASControl/GetSASControlAccess'];
  let ignoreAPI = ignoredAPIForAnalytics.filter((i) => url.includes(i));
  if (ignoreAPI.length == 0) {
    analytics.apiCall(url);
  }

  let userParam = this.$route.params['user'];
  if (!userParam) {
    if (this.$route.params['pathMatch']) {
      let path = this.$route.params['pathMatch'].split('/');
      userParam = path[2];
    }
  }

  let config = {
    method:
      method ? method
      : data ? 'post'
      : 'get',
    url: url,
    headers: {
      'Cache-Control': 'no-cache', //to avoid auto caching
    },
  };

  if (data) {
    config['data'] = data;
  }
  if (userParam) {
    config['headers']['ControlKey'] = localStorage.getItem(userParam);
  }

  try {
    // Status 200
    let result = (await Axios(config)).data;

    if (result['statusCode']) {
      // Result in APIResult format
      try {
        // Result is in JSON format
        return this.$deepTrimJsonV3(JSON.parse(result['result']));
      } catch (error) {
        // Result is not JSON
        return result['result'];
      }
    } else {
      // Result is not in APIResult format
      return result;
    }
  } catch (error) {
    // Status != 200
    if (error['response']['status'] === 401) {
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401
      Axios({
        // ================ THIS IS TEMPORARY, need to confirm that it actually fixes the "unknown user" error reports
        method: 'POST',
        url: '/ErrorReport/SilentReport',
        data: {
          pageUrl: window.location.href,
          controllerUrl: url,
        },
      });
      return;
    }

    const maintenace = (await Axios.get('/SASControl/GetMaintenancePage'))['data'];
    const URLSegments = window.location.href.split('/');
    const pageName = URLSegments[URLSegments.length - 1].replaceAll('%20', ' ');

    if (!errorObj && !maintenace.includes(pageName)) {
      // Show full page error / Severe error
      let responseStatusText;
      let errorType;

      switch (error.response.status) {
        case 601: // successfully called the backend, but reponse status indicates an error occurred (400 group or 500 group)
          responseStatusText = 'API Responded With Error';
          try {
            let parsedResult = JSON.parse(error.response.data.result);
            if (Array.isArray(parsedResult)) {
              parsedResult = parsedResult[0];
            }
            const responseErrorMessage = error.response.data.errorMessage;

            if (
              ['53'].includes(parsedResult?.ErrNo) || // 53 = A network-related or instance-specific error occurred while establishing a connection to SQL Server. The server was not found or was not accessible. Verify that the instance name is correct and that SQL Server is configured to allow remote connections. (provider: Named Pipes Provider, error: 40 - Could not open a connection to SQL Server)
              [
                // certain API endpoints won't return an error number due to how the endpoint is coded, need to check on the error message in those cases
                'A network-related or instance-specific error occurred while establishing a connection to SQL Server. The server was not found or was not accessible.',
                'A transport-level error has occurred when receiving results from the server',
                'Unable to read data from the transport connection: An existing connection was forcibly closed by the remote host',
              ].some((errorMessageSnippet) =>
                responseErrorMessage?.toLowerCase?.()?.includes(errorMessageSnippet.toLowerCase()),
              )
            ) {
              errorType = 'connectionRelatedAPIError';
            } else if (['-2', '1205'].includes(parsedResult?.ErrNo)) {
              // -2 = Execution Timeout Expired. The timeout period elapsed prior to completion of the operation or the server is not responding.
              // 1205 = Transaction (Process ID 221) was deadlocked on lock resources with another process and has been chosen as the deadlock victim. Rerun the transaction.

              errorType = 'serverLoadRelatedAPIError';
            } else {
              errorType = 'nonRetryableAPIError';
            }
          } catch (parseJSONError) {
            errorType = 'nonRetryableAPIError';
          }
          break;

        case 602: // web request timeout expired
          responseStatusText = 'Request Cancelled';
          errorType = 'serverLoadRelatedAPIError';
          break;

        case 603:
          responseStatusText = 'Unknown API Error';
          const responseErrorMessage = error.response.data?.errorMessage ?? '';
          if (
            responseErrorMessage &&
            [
              'A connection attempt failed because the connected party did not properly respond after a period of time', // could not reach the API, there's no error number to check on, need to check the error message instead
              'The SSL connection could not be established',
              'device not configured', // occurred once during development after putting the machine to sleep, waking it up, and calling an API without refreshing the page
            ].some((errorMessageSnippet) =>
              responseErrorMessage.toLowerCase().includes(errorMessageSnippet.toLowerCase()),
            )
          ) {
            errorType = 'connectionRelatedAPIError';
          } else {
            errorType = 'nonRetryableAPIError';
          }
          break;

        default:
          responseStatusText = error.response.statusText;
          errorType = 'nonRetryableAPIError';
          break;
      }

      this.$nextTick(() => {
        this.$bus.$emit(errorType, {
          pageUrl: window.location.href,
          controllerUrl: url,
          version:
            this.$store?.state?.versions?.[0]?.['Version'] ??
            'Not found. The error occurred before the version was retrieved from the API',
          user: localStorage.getItem(userParam),
          apiDetails:
            error['response']?.['data']?.['apiDetails'] instanceof Object ?
              error['response']['data']['apiDetails']
            : {
                to: error['config']['url'],
                apiKey: null, // will be assigned a value in the controller
                configCode: null, // will be assigned a value in the controller
                data:
                  typeof error['config']?.['data'] === 'string' ?
                    JSON.parse(error['config']['data'])
                  : error['config']?.['data'],
              },
          error: {
            statusCode: error['response']['status'],
            statusText: responseStatusText,
            errorMessage: error['response']['data']['errorMessage'],
            errorResponse:
              typeof error['response']['data'] == 'object' ?
                error['response']['data']
              : {
                  result: error['response']['data'],
                  statusCode: error['response']['status'],
                  errorMessage: error['response']['data'],
                  postBody: typeof data == 'string' ? data : JSON.stringify(data),
                },
          },
        });
      });
    } else {
      // Show notification error
      if (!errorObj) {
        errorObj = {};
        errorObj['message'] = error['response']['data']['errorMessage'];
      }

      let message = errorObj['message'];
      if (message) {
        message = message.replace('{{error}}', error);
        message = message.replace(
          '{{errorMessage}}',
          error['response']['status'] == 601 ?
            error['response']['data']['errorMessage']
          : error['response']['statusText'],
        );
      } else {
        // message = error;
        message = `${error} - ${error['response']['data']}`;
      }

      this.$bus.$emit('receivedNoti', {
        backgroundColor: 'pink',
        textColor: 'black',
        from: 'API Error',
        text: message,
      });
    }
  }

  // return await Axios(config);
};

Vue.prototype.$validateEmail = function (email) {
  let validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;
  return Boolean(email.match(validRegex));
};

Vue.prototype.$excelToJson = function (file, raw = true) {
  let promRes = null;
  let prom = new Promise((r) => (promRes = r));

  Vue.nextTick(() => {
    if (
      file['type'] != 'application/vnd.ms-excel' &&
      file['type'] != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      promRes({ success: false, data: 'Please provide Excel (.xls/.xlsx) file only!' });
      return;
    }

    let reader = new FileReader();
    reader.onload = (r) => {
      let excelData = XLSX.read(new Uint8Array(r['target']['result']), {
        type: 'array',
        cellText: true,
        cellDates: true,
        dateNF: 'dd"/"mm"/"yyyy',
      });
      let result = [];
      excelData['SheetNames'].forEach((s) => {
        result.push({
          sheet: s,
          data: XLSX.utils.sheet_to_json(excelData['Sheets'][s], { raw, dateNF: 'dd"/"mm"/"yyyy' }),
        });
      });

      promRes({ success: true, data: result });
    };

    try {
      reader.readAsArrayBuffer(file);
    } catch (e) {
      promRes({ success: false, data: e });
    }
  });

  return prom;
};
Vue.prototype.$jsonToExcel = async function (title, json, dataType, filters, showTitle = true) {
  if (!dataType) {
    dataType = {};
  }
  if (!filters) {
    filters = {};
  }

  let dataToDownload = JSON.parse(JSON.stringify(json));

  // deleting of dataType row moved into TableBox component instead, under the downloadExcel method
  // let hasDataType = dataToDownload.find(d => d['#'] == '0');
  // if (hasDataType) {
  //   dataToDownload = dataToDownload.slice(1);
  // }
  let excelData = [];
  if (showTitle) {
    excelData.push({
      cell: 'A1',
      value: title,
      style: {
        font: {
          sz: 18,
          bold: true,
        },
      },
    });
  }
  // let excelData = [
  // {
  //   cell: 'A1',
  //   value: title,
  //   style: {
  //     font: {
  //       sz: 18,
  //       bold: true,
  //     },
  //   },
  // },
  // ];

  let tableDataStartRow = { c: 0, r: showTitle ? 2 : 0 };

  // Adding the filters if there is any
  if (Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((k) => {
      excelData.push({
        cell: XLSX.utils.encode_cell(tableDataStartRow),
        value: `${k}: ${filters[k]}`,
      });
      tableDataStartRow['r']++;
    });

    tableDataStartRow['r']++;
  }

  let rightAlignColumns = [];
  if (Object.keys(dataType).length > 0) {
    // Added the total of the columns with data type number OR currency
    let { c, r } = XLSX.utils.decode_cell(XLSX.utils.encode_cell(tableDataStartRow));
    let totalRow = r + dataToDownload.length + 1;

    let allKeys = Object.keys(dataToDownload[0]);
    let allNumeric = Object.keys(dataType).filter((d) => dataType[d] == 'number' || dataType[d] == 'currency');
    allNumeric.forEach((n) => {
      let columnIndex = allKeys.findIndex((a) => a == n);
      rightAlignColumns.push(columnIndex);
      let totalCell = XLSX.utils.encode_cell({ c: columnIndex, r: totalRow });
      let totalValue = dataToDownload.map((d) => Number(d[n]) || 0).reduce((a, b) => a + b, 0);
      excelData.push({
        cell: totalCell,
        value: `${dataType[n] == 'currency' ? this.$currencyFormat(totalValue) : totalValue}`,
        style: {
          alignment: {
            horizontal: 'right',
          },
          fill: {
            fgColor: { rgb: 'baffb5' },
          },
        },
      });
    });
  }

  // Checking if tabledatatype is not empty and reformat the currency data type
  if (Object.keys(dataType).length > 0) {
    Object.keys(dataType).forEach((k) => {
      // Reformatting for currency data type only
      if (dataType[k] == 'currency') {
        // check if cell data is a number, if it is then format as currency, if not then don't do anything
        dataToDownload.forEach((d) => (d[k] = isNaN(Number(d[k])) ? d[k] : this.$currencyFormat(d[k])));
      }
    });
  }

  // Adding the table data
  excelData.push({
    cell: XLSX.utils.encode_cell(tableDataStartRow), // compulsory
    value: dataToDownload,
    headerStyle: {
      font: {
        bold: true,
        color: '255,255,255',
      },
      alignment: {
        horizontal: 'center',
      },
      border: {
        top: { style: 'thin', color: '155,155,155' },
        right: { style: 'thin', color: '155,155,155' },
        bottom: { style: 'thin', color: '155,155,155' },
        left: { style: 'thin', color: '155,155,155' },
      },
    },
  });

  await Vue.nextTick();
  await excel.generateAsync(excelData, {
    title: title,
    fitCol: true,
    tableTheme: '100,100,255',
    rowHighlight: true,
    rightAlign: rightAlignColumns,
  });
};

Vue.prototype.$deepTrimJson = function (json) {
  // Deprecated
  if (process.env['NODE_ENV'] == 'development') {
    console.warn('$deepTrimJson - This function is deprecated. Please use $deepTrimJsonV2 OR $deepTrimJsonV3 instead.');
  }

  if (typeof json == 'object') {
    let stringify = JSON.stringify(json);

    let regex = /"(.*?)"/g;
    let result = stringify.match(regex);
    result.forEach((r) => {
      stringify = stringify.replace(r, `"${r.substring(1, r.length - 1).trim()}"`);
    });

    return JSON.parse(stringify);
  } else {
    throw 'JSON must be an object or an array';
  }
};
Vue.prototype.$deepTrimJsonV2 = function (json) {
  // Not recommended for large data
  if (typeof json == 'object') {
    let stringify = JSON.stringify(json);
    if (stringify.length > 500000) {
      if (process.env['NODE_ENV'] == 'development') {
        console.warn(
          '$deepTrimJsonV2 - The data is too big, please use $deepTrimJsonV3 instead. Original untrim Json is returned.',
        );
      }
      return json;
    }

    // (?<=: "|:") - start with :" OR : " but not included in the result (positive lookbehind) - not supported in safari :(
    // ((.*?)(\s)|(\s)(.*?)) - select * where start OR end has white spaces
    // (?=") - ends with " but not included in the result (positive lookahead)
    // Summary - Gets all JSON values where has white spaces infront / behind
    // let result = stringify.match(/(?<=: "|:")((.*?)(\s)|(\s)(.*?))(?=")/g);
    let result = stringify.match(/(: "|:")((.*?)(\s)|(\s)(.*?))(?=")/g);
    if (result) {
      result.forEach((r) => {
        stringify = stringify.replace(r, r.trim());
      });

      return JSON.parse(stringify);
    } else {
      return JSON.parse(stringify);
    }
  } else {
    throw 'JSON must be an object or an array';
  }
};
Vue.prototype.$deepTrimJsonV3 = function (json) {
  // Recommended for everything
  if (typeof json != 'object') {
    throw 'JSON must be an object or an array';
  }

  if (Array.isArray(json)) {
    // If array
    if (json.length > 0) {
      json = json.map((j) => {
        if (typeof j == 'string') {
          return j.trim();
        } else if (j && typeof j == 'object') {
          return this.$deepTrimJsonV3(j);
        } else {
          return j;
        }
      });
    }
  } else {
    // if object
    const keys = Object.keys(json);
    keys.forEach((k) => {
      if (typeof json[k] == 'string') {
        json[k] = json[k].trim();
      } else if (json[k] && typeof json[k] == 'object') {
        json[k] = this.$deepTrimJsonV3(json[k]);
      }
    });
  }

  return json;
};

Vue.prototype.$jsonNullToString = function (json) {
  // Deprecated
  if (process.env['NODE_ENV'] == 'development') {
    console.warn('$jsonNullToString - This function is deprecated. Please use $jsonNullToStringV2 instead.');
  }

  if (typeof json == 'object') {
    let stringify = JSON.stringify(json);
    stringify = stringify.split('null,').join('"",');

    return JSON.parse(stringify);
  } else {
    throw 'JSON must be an object or an array';
  }
};
Vue.prototype.$jsonNullToStringV2 = function (json) {
  if (typeof json == 'object') {
    let stringify = JSON.stringify(json);

    // stringify = stringify.replace(/(?<=: |:)(null)(?=,|)/g, '""');
    stringify = stringify.replace(/(null)(?!")(?=,|})/g, '""');

    return JSON.parse(stringify);
  } else {
    throw 'JSON must be an object or an array';
  }
};

Vue.prototype.$fullscreenLoading = function (text, fullScreen) {
  this.$bus.$emit('mainLoading', text, fullScreen || false);
};

Vue.prototype.$topLoading = function (progressDecimal) {
  // progressDecimal should be a floating point number, min 0, max 1
  this.$bus.$emit('topLoading', progressDecimal);
};

// Alert using popupv2
let promiseSuccess = null,
  promiseError = null;
Vue.prototype.$showAlert = function (type, title, content, buttons, backgroundCancel) {
  let prom = new Promise((res, rej) => {
    promiseSuccess = res;
    promiseError = rej;
  });
  this.$bus.$emit('mainShowAlert', type, title, content, buttons, backgroundCancel, promiseSuccess);

  return prom;
};
/* How To use PopupV2
Alert using popupv2
How to use $showAlert anywhere in the application
Below is the sample code
  let alert = await this.$showAlert('error', 'Error', 'Testing Error', [
    { text: 'Delete', color: 'red', textColor: 'white' },
    { text: 'Cancel', color: 'black', textColor: 'lightgray' },
  ]);
The alert variable above returns the text of the button that you've clicked
*/
Vue.prototype.$currencyFormat = function (formatCur, decimalsPoint) {
  const format = this.$store.state.currencyFormat;

  const separatorSymbol = format[0];
  const decimalSymbol = format[1];
  let decimalPlaces = format.substring(2);
  if (decimalsPoint && !isNaN(decimalsPoint)) {
    decimalPlaces = decimalsPoint;
  }

  let fullValue = Number(formatCur).toFixed(decimalPlaces);
  let value = fullValue.split('.')[0];
  let decimalValue = fullValue.split('.')[1]; // if there are no decimal digits, this will be undefined

  let valueReversed = value.split('').reverse().join('');
  let groupedValue = valueReversed.match(/\d{1,3}/g);
  
  return `${Number(fullValue) < 0 ? '-' : ''}${groupedValue
    .map((g) => g.split('').reverse().join(''))
    .reverse()
    .join(separatorSymbol)}${decimalValue !== undefined ? `${decimalSymbol}${decimalValue}` : ''}`;
  // OLD VERSION BELOW (Issue: Not supported in Safari)
  // // Get each settings for [digit grouping symbol, decimal symbol, decimal place]
  // // From Vuex stored state
  // let preferredCurrencyFormat = this.$store.state['preferredCurrencyFormat'];
  // // Get the decimal place
  // var decimalPlace = preferredCurrencyFormat.substring(2);
  // //Format data only when it is not null (prevent TypeError cannot read null)
  // if (formatCur != null) {
  //   // Format the decimal places and digit grouping symbol
  //   formatCur = Number(formatCur).toFixed(decimalPlace).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, preferredCurrencyFormat[0]);
  //   // Get the index of the decimal symbol
  //   var decimalSymbolIndex = formatCur.length-decimalPlace-1;
  //   // Format the decimal symbol
  //   formatCur = formatCur.substring(0, decimalSymbolIndex) + preferredCurrencyFormat[1] + formatCur.substring(decimalSymbolIndex+1)
  //   // Return the currency string formatted
  //   return formatCur;
  // }
};
Vue.prototype.$weightFormat = function (formatWt) {
  // TODO: Abstract the formatting logic into a reusable method to support other formats like $currencyFormat in the future.
  const format = this.$store.state.weightFormat;

  const separatorSymbol = format[0];
  const decimalSymbol = format[1];
  const decimalPlaces = format.substring(2);

  let fullValue = Number(formatWt).toFixed(decimalPlaces);
  let value = fullValue.split('.')[0];
  let decimalValue = fullValue.split('.')[1]; // if there are no decimal digits, this will be undefined

  let valueReversed = value.split('').reverse().join('');
  let groupedValue = valueReversed.match(/\d{1,3}/g);

  return `${Number(fullValue) < 0 ? '-' : ''}${groupedValue
    .map((g) => g.split('').reverse().join(''))
    .reverse()
    .join(separatorSymbol)}${decimalValue !== undefined ? `${decimalSymbol}${decimalValue}` : ''}`;
};

Vue.prototype.$volumeFormat = function (formatVol) {
  // TODO: Abstract the formatting logic into a reusable method to support other formats like $currencyFormat in the future.
  const format = this.$store.state.volumeFormat;

  const separatorSymbol = format[0];
  const decimalSymbol = format[1];
  const decimalPlaces = format.substring(2);

  let fullValue = Number(formatVol).toFixed(decimalPlaces);
  let value = fullValue.split('.')[0];
  let decimalValue = fullValue.split('.')[1]; // if there are no decimal digits, this will be undefined

  let valueReversed = value.split('').reverse().join('');
  let groupedValue = valueReversed.match(/\d{1,3}/g);

  return `${Number(fullValue) < 0 ? '-' : ''}${groupedValue
    .map((g) => g.split('').reverse().join(''))
    .reverse()
    .join(separatorSymbol)}${decimalValue !== undefined ? `${decimalSymbol}${decimalValue}` : ''}`;
};

Vue.prototype.$getQRURL = async function (data, options) {
  // accepted properties for options object: {
  //   size: Integer; height and width of image in pixels,
  //   margin: Integer; margin between QR code and edges of the image
  // }

  if (!data) {
    if (process.env['NODE_ENV'] == 'development') {
      console.error('$getQRURL - No data provided');
    }

    return;
  }

  const userKey = localStorage.getItem(this.$route.params['user']);
  let QRURL = (
    await Axios.get('/File/GetFile?fileName=QRService.json', {
      ControlKey: userKey,
    })
  )?.['data']?.['URL'];

  if (!QRURL) {
    if (process.env['NODE_ENV'] == 'development') {
      console.error('$getQRURL - QRService.json not found');
    }

    return;
  }

  QRURL = QRURL.replace('{data}', encodeURIComponent(data));
  QRURL = QRURL.replace('{size}', encodeURIComponent(options?.['size'] ? `${options['size']}x${options['size']}` : ''));
  QRURL = QRURL.replace('{margin}', encodeURIComponent(options?.['margin'] ?? ''));

  return QRURL;
};
// to get icon based on file type
Vue.prototype.$getFileIcon = function (filename) {
  return PrettyFileIcons.getIcon(filename, 'svg');
};
// SAMPLE USAGE:
// <img :src="getIcon('file_name.pdf')">
// getIcon: function(filename) {
//   return `{RELATIVE_PATH_TO_NODE_MODULES}/node_modules/pretty-file-icons/svg/${this.$getFileIcon(filename)}`;
// }
// you need to hardcode the path to the node_modules folder based on what page you're calling this function from
// using the ~ symbol doesn't work
//#endregion

//#region JS Prototype
const shortDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const longDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const longMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

Array.prototype.getSelected = function (compare, key) {
  if (!compare || !key) {
    return null;
  }

  let selected = this.valueOf().find((v) => v[key] == compare);
  return selected ? selected : null;
};
String.prototype.toDate = function () {
  let date = new Date(Date.parse(this.valueOf()));
  if (date == 'Invalid Date') {
    console.error(`String.toDate - ${this.valueOf()} is not a valid date`);
    return null;
  } else {
    return new Date(date);
  }
};
Date.prototype.formatString = function (format) {
  let date = new Date(this.valueOf());
  if (date == 'Invalid Date') {
    console.error('Date.formatString - Date is invalid.');
    return null;
  }

  format = format.replace(/d{4}/g, longDay[date.getDay()]);
  format = format.replace(/d{3}/g, shortDay[date.getDay()]);
  format = format.replace(/d{2}/g, date.getDate().padding(2));

  format = format.replace(/M{4}/g, longMonth[date.getMonth()]);
  format = format.replace(/M{3}/g, shortMonth[date.getMonth()]);
  format = format.replace(/M{2}/g, (date.getMonth() + 1).padding(2));

  format = format.replace(/y{4}/g, date.getFullYear().toString());
  format = format.replace(/y{2}/g, date.getFullYear().toString().substring(2));

  format = format.replace(/H{2}/g, date.getHours().padding(2));
  format = format.replace(/m{2}/g, date.getMinutes().padding(2));
  format = format.replace(/s{3}/g, date.getMilliseconds().padding(3));
  format = format.replace(/s{2}/g, date.getSeconds().padding(2));

  // format = format.replace(/(?<=^|[^d])(d{2})(?=$|[^d])/g, date.getDate().padding(2));
  // format = format.replace(/(?<=^|[^d])(d{3})(?=$|[^d])/g, shortDay[date.getDay()]);
  // format = format.replace(/(?<=^|[^d])(d{4})(?=$|[^d])/g, longDay[date.getDay()]);

  // format = format.replace(/(?<=^|[^M])(M{2})(?=$|[^M])/g, (date.getMonth() + 1).padding(2));
  // format = format.replace(/(?<=^|[^M])(M{3})(?=$|[^M])/g, shortMonth[date.getMonth()]);
  // format = format.replace(/(?<=^|[^M])(M{4})(?=$|[^M])/g, longMonth[date.getMonth()]);

  // format = format.replace(/(?<=^|[^y])(y{2})(?=$|[^y])/g, date.getFullYear().toString().substring(2));
  // format = format.replace(/(?<=^|[^y])(y{4})(?=$|[^y])/g, date.getFullYear());

  // format = format.replace(/(?<=^|[^H])(H{2})(?=$|[^H])/g, date.getHours().padding(2));
  // format = format.replace(/(?<=^|[^m])(m{2})(?=$|[^m])/g, date.getMinutes().padding(2));
  // format = format.replace(/(?<=^|[^s])(s{2})(?=$|[^s])/g, date.getSeconds().padding(2));
  // format = format.replace(/(?<=^|[^s])(s{3})(?=$|[^s])/g, date.getMilliseconds().padding(3));

  return format;
};
Date.prototype.getDifference = function (date) {
  if (!(date instanceof Date)) {
    console.error('Date.getDifference - value to compare is not a Date object');
    return null;
  }

  let millis1 = this.valueOf();
  let millis2 = date.getTime();

  let diff = Math.abs(millis1 - millis2);
  let dayDiff = diff / 1000 / 60 / 60 / 24;
  let hoursDiff = (dayDiff - Math.floor(dayDiff)) * 24;
  let minutesDiff = (hoursDiff - Math.floor(hoursDiff)) * 60;
  let secondsDiff = (minutesDiff - Math.floor(minutesDiff)) * 60;
  let millisDiff =
    (secondsDiff - Math.floor(secondsDiff)) * 1000 > 995 ? 1000 : (secondsDiff - Math.floor(secondsDiff)) * 1000;

  let date1 = new Date(this.valueOf());
  let date2 = new Date(date);

  date1.setHours(0, 0, 0, 0);
  date2.setHours(0, 0, 0, 0);

  return {
    totalMillis: diff,
    millis: Math.floor(millisDiff) == 1000 ? 0 : Math.floor(millisDiff),
    seconds: Math.floor(millisDiff) == 1000 ? Math.floor(secondsDiff) + 1 : Math.floor(secondsDiff),
    minutes: Math.floor(minutesDiff),
    hours: Math.floor(hoursDiff),
    days: Math.floor(dayDiff),
    isSameDay:
      date1.getFullYear() == date2.getFullYear() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate(),
    isSameMonth: date1.getFullYear() == date2.getFullYear() && date1.getMonth() == date2.getMonth(),
    isSameYear: date1.getFullYear() == date2.getFullYear(),
  };
};
Number.prototype.padding = function (pad) {
  let result = '';
  let numSplit = this.valueOf().toString().split('.');
  let padCount = pad - numSplit[0].length;
  while (padCount > 0) {
    result += '0';
    padCount--;
  }

  return (result += numSplit.join('.'));
};
File.prototype.toBase64 = function (removeMimeType) {
  let promRes = null;
  let prom = new Promise((r) => (promRes = r));

  let reader = new FileReader();
  reader.readAsDataURL(this.valueOf());
  reader.onload = () => promRes(removeMimeType ? reader.result.split(',')[1] : reader.result);

  return prom;
};

let infoWindows = [];
google.maps.Marker.prototype.setInfoWindow = function (content, map, offset, id) {
  let openedInfoWindow = infoWindows.find((i) => i['id'] == id);

  if (!openedInfoWindow) {
    let infoWindow = new google.maps.InfoWindow({
      pixelOffset: offset ? new google.maps.Size(offset['x'] ? offset['x'] : 0, offset['y'] ? offset['y'] : 0) : null,
    });
    openedInfoWindow = { id: id, info: infoWindow };

    infoWindows.push({ id: id, info: infoWindow });
  }

  openedInfoWindow['info'].close();
  openedInfoWindow['info'].setContent(content);
  openedInfoWindow['info'].open({
    anchor: this.valueOf(),
    map: map,
  });

  google.maps.event.addListener(openedInfoWindow['info'], 'closeclick', () => {
    Bus.$emit('infoWindowClose');
  });

  return openedInfoWindow['info'];
};
//#endregion

// Converts back any currency formated string into number (float)
Vue.prototype.$currencyToNumber = function (value) {
  // Value is a string

  if (!value) {
    // Defaults value to 0 if undefined
    value = '0';
  } else if (typeof value != 'string') {
    value = value.toString();
  }

  let preferredCurrencyFormat = this.$store.state.currencyFormat;
  let numValue = value.split(preferredCurrencyFormat[0]).join('');
  numValue = numValue.split(preferredCurrencyFormat[1]).join('.');

  if (parseFloat(numValue) > Number.NEGATIVE_INFINITY) {
    return parseFloat(numValue);
  } else {
    return null;
  }
};

// Cookies.config(60 * 1.2);

router.beforeEach(async (to, from, next) => {
  Bus.$emit('pageAccessDenied', false);
  Bus.$emit('pageMaintenance', false);
  document.title = to.meta.title;

  if ($cookies.get('user') != null) {
    document.title += ` (${$cookies.get('user').UserID})`;
  }

  Bus.$emit('routeChanged', to);
  next();
});

router.afterEach(async (to, from) => {
  // For changing the tab icon
  let userKey = localStorage.getItem(to['params']['user']);
  let icon = document.getElementById('pageIcon');

  let pathArray = to.path.split('/');
  let module = pathArray[3];
  let page = pathArray[pathArray.length - 1];

  if (userKey) {
    //#region Checking SAS for pages
    if (module && page) {
      // If can find module and page from the path
      let pageItem = SubMenu.getMenus();
      let moduleItems = pageItem.find((p) => p['module'] == module);

      if (moduleItems) {
        //check first on module is it enabled
        Axios.get(`/SASControl/GetSASControlAccess?page=HOME`, {
          headers: {
            ControlKey: userKey,
          },
        }).then((res) => {
          let result = JSON.parse(res['data']['result']);
          let hasSAS = result.find((r) => r['Control'] == moduleItems['key']);

          if (hasSAS && (hasSAS['Properties'] == 'Visible' || hasSAS['Properties'] == 'Enabled') &&
            hasSAS['PropertiesValue'] == 'False') {
            // If the current module is set the visible false
            if (process.env['NODE_ENV'] == 'development') {
              console.log('No Access to this page (pageAccessDenied)');
            }
            Bus.$emit('pageAccessDenied', true);
          }
        })
        // If the module exists in the sub menu
        let currentPage = moduleItems['items'][page];
        if (!currentPage) {
          // For master files / any module that has multi sections
          let keys = Object.keys(moduleItems['items']);
          let pages = [];

          keys.forEach((k) => {
            if (Array.isArray(moduleItems['items'][k]['pages'])) {
              pages.push(...moduleItems['items'][k]['pages']);
            } else {
              pages.push(moduleItems['items'][k]);
            }
          });

          if (pages.length > 0) {
            currentPage = pages.flat().find((p) => p['title'].replaceAll(' ', '').replaceAll('/', '') == page);
          }
        }

        if (currentPage?.['key']) {
          // If can find current page in the module items, AND it has a key property
          Axios.get(`/SASControl/GetSASControlAccess?system=${moduleItems['key']}`, {
            headers: {
              ControlKey: userKey,
            },
          }).then((res) => {
            let result = JSON.parse(res['data']['result']);
            let hasSAS = result.find((r) => r['Control'] == currentPage['key']);
            if (hasSAS) {
              // Current page is in the SAS Control API
              if (
                (hasSAS['Properties'] == 'Visible' || hasSAS['Properties'] == 'Enabled') &&
                hasSAS['PropertiesValue'] == 'False'
              ) {
                // If the current page is set the visible false
                if (process.env['NODE_ENV'] == 'development') {
                  console.log('No Access to this page (pageAccessDenied)');
                }
                Bus.$emit('pageAccessDenied', true);
              }
            }

            Axios.get(
              `/SASControl/GetSASControlAccess?system=${moduleItems['key']}&page=${currentPage['pageSasKey'] || currentPage['title']}`,
              {
                headers: {
                  ControlKey: userKey,
                },
              },
            ).then((res) => {
              let result = JSON.parse(res['data']['result']);
              if (process.env['NODE_ENV'] == 'development') {
                console.log('Page access control', result);
              } //yk
              Bus.$emit('pageSASControlAccess', { page: currentPage['title'], data: result });
            });
          });
        }
      }
    }
    //#endregion

    let result = (await Axios.get(`/Login/GetDetails?key=${userKey}`))['data'];
    if (result) {
      Vuex.commit('updateLoginDetails', result);
      icon.href = result['FavIcon'];
      document.title = `6G ${result['CoRefname']} - ${document.title}`;

      if (!result['ConfigCode'].toLowerCase().includes('dsm6g') && to['meta']['title'] == 'Broadcast Message') {
        Bus.$emit('pageAccessDenied', true);
      }
    }
  } else {
    document.title = to.meta.title;
    icon.href = '/elmslogo.ico';
  }

  // Getting the maintenance page
  Axios.get('/SASControl/GetMaintenancePage').then((r) => {
    let maintenancePage = r['data'];
    if (maintenancePage.includes(page)) {
      Bus.$emit('pageMaintenance', true);
    }
  });
});

//#region Google Maps
Vue.use(GoogleMap, {
  load: {
    key: 'AIzaSyDDWYXwTHojT7irJMVa4eiMv6jIn1nptUg',
    libraries: ['directions', 'places'],
  },
});
//#endregion

window.excel = excel;
window.analytics = analytics;
window.db = db;

new Vue({
  render: (h) => h(App),
  router,
  store: Vuex,
}).$mount('#app');
